import { useOnboarding } from "@/hooks/use-onboarding";
import { mediumImpact } from "@/utils/capacitorUtils";
import { IonContent, IonPage } from "@ionic/react";
import { motion } from "framer-motion";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

const MotivationSelection: React.FC<{ nextStep: string }> = ({ nextStep }) => {
  const { t } = useTranslation("MGP");
  const history = useHistory();
  const { updateOnboardingData } = useOnboarding()

  const [selectedMotivation, setSelectedMotivation] = useState<string | null>(null);

  // Simplified motivations list
  const motivations = [
    //{ id: "improve", icon: "📈", name: t("improve_my_game"), description: t("focus_on_skills_and_techniques") },
    { id: "active", icon: "💪", name: t("stay_active_healthy"), description: t("use_golf_to_stay_fit") },
    { id: "relax", icon: "🌴", name: t("have_fun_and_relax"), description: t("play_golf_to_relax_and_unwind") },
    { id: "socialize", icon: "🤝", name: t("socialize_and_connect"), description: t("meet_other_golfers_and_network") },
    //{ id: "track", icon: "📊", name: t("track_my_progress"), description: t("analyze_performance_and_scores") },
    { id: "learn", icon: "🔰", name: t("learn_golf"), description: t("learn_how_to_golf") },
    { id: "pro", icon: "🏌️", name: t("pro_of_golf"), description: t("learn_how_to_golf") },
  ];

  const handleNext = async (motivation: string) => {
    mediumImpact()
    await updateOnboardingData({ motivation })
    setSelectedMotivation(motivation)
    console.log("Selected Motivation:", motivation);
    history.push(nextStep); // Navigate to the next step
  };

  return (
    <IonPage>
      <IonContent scrollY={false}>
        <div
          className="flex flex-col items-center justify-center px-2 bg-card h-full"
        >
          <div className="w-full max-w-xl">
            <h1 className="mb-4 text-2xl font-bold">{t("what_motivates_you_to_play")}</h1>
            {/* Vertical List of Motivations */}
            <div className="w-full space-y-4">
              {motivations.map((motivation) => (
                <motion.div
                  key={motivation.id}
                  className={`flex items-center p-4 rounded-lg bg-card hover:bg-input cursor-pointer shadow-sm border ${selectedMotivation === motivation.id
                    ? "border-primary bg-primary/10"
                    : "border-input"
                    }`}
                  onClick={() => { setSelectedMotivation(motivation.id); handleNext(motivation.id); }}
                >
                  <div className="text-4xl mr-4">{motivation.icon}</div>
                  <div>
                    <div className="font-medium text-base">{motivation.name}</div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default MotivationSelection;